import TemplateValidation from "../../common/utils/TemplateValidation";
import SvlanChecker from '../../shared/SvlanChecker';

export default class ExtranetOrdersNew {
    constructor() {
        this.validation_client = null;
        this.validation_technical = null;
        this.svlanChecker = null;

        this.initValidation();
        this.bindEvents();
        this._initSvlanChecker();
        //window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
        $(".next").click(this.onNext);
        $(".prev").click(this.onPrev);

        let $select2 = $("#options_select")
        $select2.select2({
            multiple: true,
            closeOnSelect: false
        });
        $select2.val("")
        $select2.trigger("change");
        $select2.change(this.onOptionChanged);

        $("#quote_client_form input").change(this.onInputChanged);
        $("#quote_technical_form input").change(this.onInputChanged);
        $("#quote_client_form select").change(this.onInputChanged);
        $("#quote_technical_form select").change(this.onInputChanged);

        $("#quote_client_form").on("submit", this.onSubmit);
        $("#quote_technical_form").on("submit", this.onSubmit);
        $('a[data-toggle="tab"]').on("shown.bs.tab", this.validateForm);
        $('a[data-toggle="tab"][href="#summary"]').on("click.svlanGuard", this.guardSummaryTab);
        $(window).keydown(this.preventEnterKey);
        $("#delivery_interface").change(this.onDeliveryInterfaceChanged);

        $("#submit_quote").click(this.onSubmitQuote);

        this.setupSvlanVisibility();
    }

    onDataChanged(data) {
    }

    _initSvlanChecker() {
        const checkUrl = $('#svlan').data('svlan-check-url');
        if (!checkUrl) return;

        this.svlanChecker = new SvlanChecker({
            checkUrl,
            submitSelector: '#submit_quote, .next[data-target="#summary"]',
        });
    }

    onDestroy() {
        if (this.svlanChecker) this.svlanChecker.destroy();
        $("#options_select").select2("destroy");

        if(this.validation_client !== undefined && this.validation_client !== null){
            this.validation_client.destroy();
        }

        if(this.validation_technical !== undefined && this.validation_technical !== null){
            this.validation_technical.destroy();
        }
    }

    onNext(e) {
        let self = application.current_handler;
        const target = $(e.target).data("target");

        if (target === '#summary' && self.svlanChecker && (!self.svlanChecker.isAvailable || self.svlanChecker.isChecking)) {
            return false;
        }

        self.moveToTab(target);
    }

    onPrev(e) {
        let self = application.current_handler;
        self.moveToTab($(e.target).data("target"));
    }

    moveToTab(id){
      $("a[href='"+id+"']").tab("show");
    }

    loadSummary(){
      console.log("loadSummary");
    }

    onOptionChanged(e){
        let self = application.current_handler;
        let options = $("#options_select option:selected")
        let fas = 0;
        let subscription = 0;
        options.each(function(){
            fas += Number.parseFloat($(this).data("fas"));
            subscription += Number.parseFloat($(this).data("subscription"));
        })

        $("#fas_options").text(I18n.toCurrency(fas));
        $("#subscription_options").text(I18n.toCurrency(subscription));

        let fas_total = Number.parseFloat($("#fas_product").data("price")) + fas;
        $("#fas_total").text(I18n.toCurrency(fas_total));

        // Check if we have separate columns for annual pricing
        let hasSeperateColumns = $("#subscription_options_total").length > 0;
        if (hasSeperateColumns) {
            // Annual pricing: only update the monthly options total, product total stays separate
            $("#subscription_options_total").text(I18n.toCurrency(subscription));
        } else {
            // Regular pricing: combine product + options
            let subscription_total = Number.parseFloat($("#subscription_product").data("price")) + subscription;
            $("#subscription_total").text(I18n.toCurrency(subscription_total));
        }

        $("#summary_fas_options").text(I18n.toCurrency(fas));
        $("#summary_subscription_options").text(I18n.toCurrency(subscription));

        let summary_fas_total = Number.parseFloat($("#fas_product").data("price")) + fas;
        $("#summary_fas_total").text(I18n.toCurrency(summary_fas_total));

        if (hasSeperateColumns) {
            $("#summary_subscription_options_total").text(I18n.toCurrency(subscription));
        } else {
            let summary_subscription_total = Number.parseFloat($("#subscription_product").data("price")) + subscription;
            $("#summary_subscription_total").text(I18n.toCurrency(summary_subscription_total));
        }

        $("#summary_options").text(options.map(function(){return $(this).text()}).get().join(", "));

    }

    onInputChanged(e){
        let input = $(e.target);
        let value = input.val().trim();
        let id = input.attr("id");
        let target = $("#summary_"+id);

        if(target){
            if(value === "" || value == null){value = "-";console.log(value)}
            console.log(value);
            console.log("target", target);
            target.text(value);
        }
    }

    initValidation(){
        this.validation_client = new TemplateValidation(this.validationData(), "#quote_client_form", {ignore: []});
        this.validation_technical = new TemplateValidation(this.validationData(), "#quote_technical_form", {ignore: []});
    }

    validationData(){
        let data = {
            "order[customer_entity]": {
                required: true,
                minlength: 2
            },
            "order[customer_full_name]": {
                required: true,
                minlength: 2
            },
            "order[customer_email]": {
                email: true
            },
            "order[customer_phone]": {
                phone_number_fr: true
            },
            "order[coordinates]": {
            },
            "order[extra]": {
            },
            "order[collect_gate]": {
            },
            "order[collect_gate_b]": {
            },
            "order[svlan]": {
            },
            "order[delivery_interface]": {
                required: true,
            },
            "order[type_interface]": {
                required: true,
            },
            "order[commercial_partner_ref]": {
            }
        };
        if ($("#pdc_order_id").length) {
            data["order[pdc_order_id]"] = { required: $("#pdc_order_id").prop("required") };
        }
        return data;
    }

    onSubmit(e){
        e.preventDefault();
        e.stopPropagation();

        return false;
    }

    guardSummaryTab(e) {
        const self = application.current_handler;
        if (self.svlanChecker && (!self.svlanChecker.isAvailable || self.svlanChecker.isChecking)) {
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        }
    }

    validateForm(e) {
        if($(e.target).attr("href") === "#technical_info"){
            if(!$("#quote_client_form").valid()){
                $("a[href='#client_info']").tab("show");
                return false;
            }
        }
        if($(e.target).attr("href") === "#summary"){
            if(!$("#quote_client_form").valid()){
                $("a[href='#client_info']").tab("show");
                return false;
            }
            if(!$("#quote_technical_form").valid()){
                $("a[href='#technical_info']").tab("show");
            }
        }
    };

    preventEnterKey(e) {
        if(e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    }

    onDeliveryInterfaceChanged(e){
        let $el = $(this);
        let $typeInterface = $("#type_interface");
        let isOptical = $el.val() === "Optique";
        $typeInterface.prop("disabled", !isOptical);
        if(!isOptical){ $typeInterface.val(""); }
    }

    onSubmitQuote(e){
        let self = application.current_handler;
        let hasError = false;

        // Client-side SVLAN range check (Nextree form)
        const $svlanInput = $('#svlan');
        const $svlanGroup = $('#svlan-group');
        if ($svlanGroup.length && $svlanGroup.is(':visible') && $svlanInput.val() !== '') {
            const svlanVal = parseInt($svlanInput.val(), 10);
            const svlanMin = parseInt($svlanInput.attr('min'), 10) || 2;
            const svlanMax = parseInt($svlanInput.attr('max'), 10) || 4091;
            if (isNaN(svlanVal) || svlanVal < svlanMin || svlanVal > svlanMax) {
                hasError = true;
                $svlanInput.addClass('is-invalid');
                $('#svlan-error').show();
            } else if (self.svlanChecker && !self.svlanChecker.isAvailable) {
                hasError = true;
            } else {
                $svlanInput.removeClass('is-invalid');
                $('#svlan-error').hide();
            }
        }

        if(!$("input#cgu").is(":checked")) {
            hasError = true;
            $("label[for='cgu']").addClass("text-danger");
        }else{
            $("label[for='cgu']").removeClass("text-danger");
        }

        if(!$("input#cgp").is(":checked")) {
            hasError = true;
            $("label[for='cgp']").addClass("text-danger");
        }else{
            $("label[for='cgp']").removeClass("text-danger");
        }

        if(!hasError){
            application.openLoader();
            let fd = new FormData();
            $("input, select, textarea").each(function(){
                let $el = $(this);
                
                let name = $el.attr("name");
                let value = $el.val();
                if(name !== undefined && (name.startsWith("order") || name.startsWith("options"))){
                    // Handle select2 multiple values: append each value separately for array fields
                    if(Array.isArray(value)) {
                        value.forEach(function(v) {
                            fd.append(name, v);
                        });
                    } else {
                        fd.append(name, value);
                    }
                }
            });
            fd.append("product_id", application.getParam('product_id'));
            fd.append("request_id", application.getParam('request_id'));

            $.ajax({
                url: $("#quote_client_form").attr("action"),
                method: "POST",
                data: fd,
                processData: false,
                contentType: false,
                success: function(data){},
                error: function(data){
                    console.log(data);
                }
            })
        }
    }

    setupSvlanVisibility() {
        const $pdcSelect = $('.js-pdc-select');
        if ($pdcSelect.length === 0) return;

        const $svlanGroup = $('#svlan-group');
        const $svlanInput = $('#svlan');
        const $svlanError = $('#svlan-error');

        const toggleSvlan = () => {
            const hasValue = $pdcSelect.val() !== '' && $pdcSelect.val() !== null;
            $svlanGroup.toggle(hasValue);
            $svlanInput.val('');
            $svlanInput.removeClass('is-invalid is-valid');
            $svlanError.hide();
        };

        $pdcSelect.on('change', toggleSvlan);
        toggleSvlan();

        $svlanInput.on('input change', function () {
            const val = parseInt($(this).val(), 10);
            const min = parseInt($(this).attr('min'), 10) || 2;
            const max = parseInt($(this).attr('max'), 10) || 4091;
            if (isNaN(val) || val < min || val > max) {
                $(this).addClass('is-invalid');
                $svlanError.show();
            } else {
                $(this).removeClass('is-invalid');
                $svlanError.hide();
            }
        });
    }
}